<div class="container-fluid">
    <div class="row fondoAmarillo">
        <div class="col-lg-2">
            <img src="assets/img/auri.png" height="60px">
        </div>
        <div class="col-lg-8">
            <br>
            <p class="center blanco">¡Bienvenido <span class="bold">{{dataUsuario.first_name}}</span>!</p>
           
        </div>
        <div class="col-lg-2">
            <br>
            <p><a class="blanco bold" (click)="closeSesion()">Cerrar Sesión</a></p>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-10">
            <div class="row">
                <div *ngIf="avance == 999">
                    <br>
                    <h1 class="text-center">¡Bienvenido a Auri!</h1>
                    <p class="text-center">Antes de comenzar, te invitamos a ver este breve video introductorio que te mostrará 
                        todas las increíbles funciones y posibilidades que encontrarás aquí. ¡Disfruta y prepárate 
                        para una experiencia única!
                    </p>
                    <br>

                    <div class="row">
                        <div class="col-2"></div>
                        <div class="col-8">
                            <div *ngIf="contenido.video;">
                                <video src="{{environment}}{{contenido.video}}"  width="100%" controls>
                                    Tu navegador no admite el elemento <code>video</code>.
                                </video>
                            </div>

                            <br>
                            <p class="text-center">
                                <button class="fondoAmarillo border0 input90 bold blanco" (click)="actualizarAvanceVideo(clienteId)">Siguiente</button>
                            </p>
                        </div>
                    </div>
                    
                    
                </div>
                <div *ngIf="avance == 0">
                    <br>
                    <h5 class="center">¡Por favor elige tu paquete!</h5>
                    <br>
                    <div class="row">
                        <div class="col-lg-3" *ngFor="let paquete of paquetes">
                            <div *ngIf="paquete.imagen; else imagenAuri">
                                <div class="img-magnifier-container">
                                    <img src="{{environment}}{{paquete.imagen}}" width="100%">
                                </div>


                                            
                            </div>
                            <ng-template #imagenAuri>
                                <img src="assets/img/auri.png" width="100%"><br>
                            </ng-template>
                            <p class="center">{{paquete.nombre}}
                                <br><strong>${{paquete.precio}}</strong><br>
                                <span (click)="getDetallePaquete(paquete.id)">Ver Detalles</span>
                            </p>
                            <div *ngIf="solicitado==0">
                                <button class="fondoAmarillo border0 input90" (click)="agregarPaqueteCliente(paquete.id, clienteId)">Agregar Paquete</button><br><br>
                            </div>
                        </div>
                    </div>
                    
                </div>

                <div *ngIf="avance == 1">
                    <br>
                        <h5 class="center">¡Por favor elige un marco!</h5>
                    <br>
                    <div class="row">
                        
                        <div *ngFor="let moldura of molduras" class="col-lg-3 col-sm-3 col-md-3 col-6">
                            <div *ngIf="moldura.imagen; else imagenAuri4">
                                <img src="{{environment}}{{moldura.imagen}}" width="100%">
                            </div>
                            <ng-template #imagenAuri4>
                                <img src="assets/img/auri.png" width="100%"><br>
                            </ng-template>
    
                            <p class="center">{{moldura.nombre}}</p>
                            <div *ngIf="solicitado==0">
                                <button class="fondoAmarillo border0 input90" (click)="agregarMoldura(moldura.id, clienteId)">Elegir Marco</button><br><br>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="avance == 2">
                    <br>
                        <h5 class="center">¡Por favor elige un color!</h5>
                    <br>
                    <div class="row">
                        <div *ngFor="let color of colores" class="col-lg-3 col-sm-3 col-md-3 col-6">
                            <div *ngIf="color.imagen; else imagenAuri3">
                                <img src="{{environment}}{{color.imagen}}" width="100%">
                            </div>
                            <ng-template #imagenAuri3>
                                <img src="assets/img/auri.png" width="100%"><br>
                            </ng-template>

                            <p class="center">{{color.nombre}}</p>
                            <div *ngIf="solicitado==0">
                                <button class="fondoAmarillo border0 input90" (click)="agregarColor(color.id, clienteId)">Elegir Color</button><br><br>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="avance == 3">
                    <br>
                    <h5 class="center">¡Por favor elige una placa!</h5>
                    <br>
                    <div class="row">
                        <div *ngFor="let placa of placas" class="col-lg-3 col-sm-3 col-md-3 col-6">
                            <div *ngIf="placa.imagen; else imagenAuri2">
                                <img src="{{environment}}{{placa.imagen}}" width="100%"><br>
                            </div>
                            <ng-template #imagenAuri2>
                                <img src="assets/img/auri.png" width="100%"><br>
                            </ng-template>

                            <p class="center">{{placa.nombre}}</p>
                            <div *ngIf="solicitado==0">
                                <button class="fondoAmarillo border0 input90" (click)="agregarPlaca(placa.id, clienteId)">Elegir Placa</button><br><br>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="avance == 4">
                    <br>
                    <!-- <h5 class="center">¡Por favor elige tu dedicatoria!</h5> -->
                    <div class="row">
                        <div class="col-lg-9"></div>
                        <div class="col-lg-3">
                            <button class="btn btn-success" (click)="omitirDedicatoria(clienteId)">Omitir Dedicatoria</button>
                        </div>
                    </div>
                    <h5>A quién va dirigido (Por ej.: A mis padres):</h5>
                    <!-- <span>Dirigiado a  (50 Caracteres máximo):</span><br> -->
                    <input type="text" [(ngModel)]="dedicatoriaPersonalizada.dirigido" maxlength="50" class="form-control"><br>
                    
                    <h5>Elige un texto de dedicatoria:</h5>
                    <div class="row">
                        <div *ngFor="let dedicatoria of dedicatorias; let positionDedicatoriaAnillo=index" class="col-lg-6 col-sm-6 col-md-3 col-6">
                            <p class="center"><strong>{{dedicatoria.nombre}}</strong>
                            <br>{{dedicatoria.texto}}<br></p>
                            <div *ngIf="solicitado==0">
                                <button class="fondoAmarillo border0 input90" (click)="agregarDedicatoriaCliente(dedicatoria.nombre, dedicatoria.texto, dedicatoriaPersonalizada.dirigido, clienteId)">Elegir Dedicatoria</button><br><br>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="avance == 5" >
                    <br>
                    <h5>Confirma tu Paquete</h5>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <td>Producto</td>
                                <td>Precio</td>
                                <td><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                    </svg></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let paqueteSelected of paquetesSeleccionados">
                                <td>{{paqueteSelected.paquete}}</td>
                                <td>{{paqueteSelected.precio | currency}}</td>
                                <td>
                                    <button class="btn btn-danger" (click)="eliminarPaqueteRegistrarme(paqueteSelected.id, clienteId)">
                                        Eliminar
                                    </button>
                                    
                                </td>
                            </tr>

                            <tr *ngFor="let placaSelected of placasSeleccionados">
                                <td>Placa - {{placaSelected.nombre}} </td>
                                <td> - </td>
                                <td>
                                    <button class="btn btn-danger" (click)="eliminarPlacaRegistrarme(placaSelected.id, clienteId)">
                                        Eliminar
                                    </button>
                                </td>
                            </tr>
                
                            <tr *ngFor="let molduraSelected of moldurasSeleccionados">
                                <td>Marco - {{molduraSelected.nombre}}</td>
                                <td> - </td>
                                <td>
                                    <button class="btn btn-danger" (click)="eliminarMarcoRegistrarme(molduraSelected.id, clienteId)">
                                        Eliminar
                                    </button>
                                </td>
                            </tr>

                            <tr *ngFor="let coloreSelected of coloresSeleccionados">
                                <td> Color - {{coloreSelected.nombre}} </td>
                                <td> - </td>
                                <td>
                                    <button class="btn btn-danger" (click)="eliminarColorRegistrarme(coloreSelected.id, clienteId)">
                                        Eliminar
                                    </button>
                                </td>
                            </tr>

                            <tr *ngFor="let dedicatoriaSelected of dedicatoriasSeleccionadas">
                                <td>{{dedicatoriaSelected.nombre}}<br>
                                    Dirigido a:<br>
                                    {{dedicatoriaSelected.dirigido}}
                                </td>
                                <td>{{dedicatoriaSelected.texto}}</td>
                                <td>
                                    <button class="btn btn-danger" (click)="eliminarDedicatoriaRegistrarme(dedicatoriaSelected.id, clienteId)">
                                        Eliminar
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <button  class="fondoAmarillo border0 input90 bold" (click)="solicitarPaqueteRegistrarme(clienteId)">Solicitar Paquete</button><br><br> 
                        

                    <!-- <h5>Realiza tu pago</h5>
                    <app-stripe-pay (changeStripeTok)="validStripe($event)"></app-stripe-pay>   -->
                </div>
                
            </div>
        </div>
        <div class="col-lg-1"></div>
    </div>

    
</div>

<div id="clickPaquete" (click)="openModal(mymodal2)"></div>
<ng-template #mymodal2 let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{nombrePaquete}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="dismissAll()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body">
        <p>{{descripcion}}</p>

        <h5>Incluye:</h5>
        <img src="{{environment}}{{paqueteImagen}}" width="300px">
        <ul>
            <li *ngFor="let producto of detallePaquete">{{producto.nombre}}</li>
        </ul>
        
        <button class="btn btn-warning" (click)="agregarPaqueteCliente(paqueteid, clienteId)">Agregar</button>

    </div>
    <div class="modal-footer">
       

    </div>
</ng-template>